import { render, staticRenderFns } from "./UISider.vue?vue&type=template&id=3f1fd4de&"
import script from "./UISider.vue?vue&type=script&lang=js&"
export * from "./UISider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports